import { http } from 'http';

export default {
  customerMeFull: options => {
    if (options && options.authBtk2fa) {
      return http.get('/bconnect/me-full', { authBtk: true, authBtk2fa: true });
    }
    return http.get('/bconnect/me-full', { authBtk: true, authBtk2fa: false });
  },

  fetchAccounts: () => http.get('/bconnect/accounts'),

  accountDetails: accountId => http.get(`/bconnect/accounts/${accountId}`, { authBtk: true }),

  getUrlBBVA: idOffer => http.get(`/bconnect/GetUrlBBVA/${idOffer}`)
};
